import '../css/main.scss';
import '../css/_easing.scss';
import '../css/_mixin.scss';
import Canvas from './modules/Canvas';
import Canvas_tex from './modules/Canvas_tex';
import Img_mock from "./modules/Img_mock";

const domReady = () => {
  if (document.readyState != 'loading' && document.body) return Promise.resolve();
  return new Promise((f, r) => {
    document.addEventListener('DOMContentLoaded', f);
  });
};
domReady().then(() => {

  const elm = document.getElementById('output');
  const isVertexMock= document.getElementById('vertex');
  elm.innerHTML = 'HELLO!!';
  let canvas=null;
  if(isVertexMock){
    canvas = new Canvas();
  }else{
    canvas = new Canvas_tex();
  }

  window.addEventListener('resize', resized.bind(this));
  resized();
  update();

  function resized() {
    canvas.resized()
  }

  function update() {
    canvas.updated()
    requestAnimationFrame(update);
  }
});
